import React from 'react';
import InquiryList from '../../inquiry/InquiryList';

/**
 * 문의 목록 스크린 컴포넌트
 */
const InquiryListScreen = () => {
  return <InquiryList />;
};

export default InquiryListScreen;